module.exports = __webpack_public_path__ + "static/eng-98061b789cd9f933a0fd870c25b02298.png";